'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var fi = require('react-icons/fi');
var usehooksTs = require('usehooks-ts');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const TunzSelect = ({ options, onChange = () => undefined, defaultValue }) => {
    var _a;
    const [isOpen, setIsOpen] = React.useState(false);
    const [filteredOptions, setFilteredOptions] = React.useState(options);
    const [selected, setSelected] = React.useState(defaultValue || ((_a = filteredOptions[0]) === null || _a === void 0 ? void 0 : _a.value));
    const [searchValue, setSearchValue] = React.useState('');
    const [currentOption, setCurrentOption] = React.useState(0);
    const elementRef = React.useRef(null);
    const searchRef = React.useRef(null);
    const listRef = React.useRef(null);
    const optionRefs = React.useRef(filteredOptions.map(() => React.createRef()));
    const selectedOption = options.find((option) => option.value === selected);
    const toggle = () => {
        setIsOpen(!isOpen);
    };
    const handleClickOutside = () => {
        setIsOpen(false);
    };
    usehooksTs.useOnClickOutside(elementRef, handleClickOutside);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (isOpen && searchRef.current) {
            searchRef.current.focus();
        }
        if (isOpen && ((_b = (_a = optionRefs.current[currentOption]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView) !== undefined) {
            (_d = (_c = optionRefs.current[currentOption]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.scrollIntoView();
        }
    }, [isOpen, currentOption]);
    React.useEffect(() => {
        setFilteredOptions(options.filter((o) => o.label.toLowerCase().includes(searchValue.toLowerCase())));
    }, [options, searchValue]);
    const handleOnClick = (option) => {
        onChange(option.value);
        setSelected(option.value);
        toggle();
    };
    const onSearch = (event) => {
        const target = event.currentTarget;
        setSearchValue(target.value);
    };
    const positionHandler = (ev) => {
        if (filteredOptions.length > 0) {
            const lastIndex = filteredOptions.length - 1;
            let newPosition = 0;
            switch (ev.key) {
                case 'Enter': {
                    handleOnClick(filteredOptions[currentOption]);
                    return;
                }
                case 'ArrowDown': {
                    newPosition = currentOption + 1 > lastIndex ? 0 : currentOption + 1;
                    break;
                }
                case 'ArrowUp': {
                    newPosition = currentOption - 1 < 0 ? lastIndex : currentOption - 1;
                    break;
                }
            }
            setCurrentOption(newPosition);
        }
    };
    const onKeyDown = (event) => {
        const ev = event;
        // isOpen : to apply on key press changes only to this input
        if (isOpen) {
            if (ev.key === 'Escape' && isOpen) {
                setIsOpen(false);
                return;
            }
            positionHandler(ev);
        }
    };
    usehooksTs.useEventListener('keydown', onKeyDown, listRef);
    return (React__default["default"].createElement("div", { "data-testid": "tunzSelect-renderer", className: "renderer-dropdown", ref: elementRef },
        React__default["default"].createElement("div", { role: "button", tabIndex: 0, className: "renderer-header", onKeyDown: () => toggle(), onClick: () => toggle() },
            React__default["default"].createElement("div", { className: "renderer-header-title-wrapper" },
                React__default["default"].createElement("p", { className: "renderer-header-title", style: { color: `${selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.color}` }, "data-testid": "renderer-title" }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label)),
            React__default["default"].createElement("div", { className: "renderer-header-action-wrapper" },
                React__default["default"].createElement("div", { className: "renderer-header-action", "data-testid": "toggle-dropdown" }, isOpen ? React__default["default"].createElement(fi.FiChevronUp, { size: 18 }) : React__default["default"].createElement(fi.FiChevronDown, { size: 18 })))),
        isOpen && (React__default["default"].createElement("ul", { className: "renderer-list", "data-testid": "renderer-dropdown" },
            React__default["default"].createElement("div", { className: "search-box" },
                React__default["default"].createElement("input", { onChange: onSearch, value: searchValue, ref: searchRef, "data-testid": "tunzSelect-renderer-input" })),
            React__default["default"].createElement("div", { ref: listRef }, filteredOptions.map((option, index) => (React__default["default"].createElement("li", { className: `renderer-list-item ${index === currentOption ? 'renderer-list-item-selected' : ''} ${option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)
                    ? 'renderer-list-item-current'
                    : ''}`, value: option.value, key: option.value, ref: optionRefs.current[index], tabIndex: index },
                React__default["default"].createElement("button", { type: "button", onClick: () => handleOnClick(option), "data-testid": `option-button-${option.value}`, "data-index": index },
                    React__default["default"].createElement("span", { style: { color: `${option.color}` } }, option.label))))))))));
};

exports["default"] = TunzSelect;
